<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>
        <template slot="schools" slot-scope="schools">
          <span class="font-weight-bold">{{schools}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <edit-board ref="editBoard" @edited="handleEdited"/>
  </div>
</template>
<script>
import EditBoard from '@/components/board/Forms/Edit/index'

const columns = [
  {
    title: 'Boards',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Descriptions',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Schools',
    dataIndex: 'schools_count',
    key: 'schools_count',
    scopedSlots: { customRender: 'schools' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'BoardsTable',
  components: {
    EditBoard,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editBoard.showModal(record.id)
      this.$eventBus.$emit('openBoardEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this board?',
        content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/board/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
